<app-organizer-shared-layout-funnel [class]="builtLayoutCssClass">
  <app-organizer-shared-page-container>
    <h1 *ngIf="stepsTitleKey" class="text-vtmn-play-content-brand title-4">
      {{ stepsTitleKey | translate }}
    </h1>
    <app-timeline
      [collection]="steps"
      [subTitle]="stepsSubTitleKey | translate"
    ></app-timeline>

    <app-organizer-shared-navigation-buttons
      nextQueryParametersHandling="preserve"
      previousQueryParametersHandling="preserve"
      [nextDisabled]="false"
      [nextLabel]="
        'shared_organizer.steps.navigation_buttons.next.label' | translate
      "
    ></app-organizer-shared-navigation-buttons>
  </app-organizer-shared-page-container>

  <app-beveled-picture
    layout-right-content
    class="steps-picture"
    [src]="imageSource"
  ></app-beveled-picture>
</app-organizer-shared-layout-funnel>
